/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Voice_Demo_TitleInputs */

const en_features_voice_demo_title = /** @type {(inputs: Features_Voice_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"She sounds just like a real person!"`)
};

const es_features_voice_demo_title = /** @type {(inputs: Features_Voice_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"¡Suena como una persona real!"`)
};

/**
* | output |
* | --- |
* | "\"She sounds just like a real person!\"" |
*
* @param {Features_Voice_Demo_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_voice_demo_title = /** @type {((inputs?: Features_Voice_Demo_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Voice_Demo_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_voice_demo_title(inputs)
	return en_features_voice_demo_title(inputs)
});